import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {PopupField} from './PopupField.jsx';
import {DeliveryAddressPopup} from './DeliveryAddressPopup.jsx';
import {isAddressIdentical} from '../../../../utils/address';

/**
 * Delivery address field:
 *  - disabled text field with an adornment button that open the popup
 *  - a popup that split the address in many fields and regroup them on save
 * @param {!Object} props
 * @return {JSX.Element}
 */
export const DeliveryAddressField = (props) => {
    const [open, setOpen] = useState(false);

    /**
     *
     * @param {DeliveryAddress} deliveryAddress
     * @return {string}
     */
    const deliveryAddressAsString = (deliveryAddress) => {
        if (!deliveryAddress) {
            return '';
        }
        const nonEmptyParts = [];
        for (const key of ['name', 'name2', 'houseNumber', 'street', 'postalCode', 'city', 'state', 'country']) {
            const part = deliveryAddress?.[key]?.trim?.();
            if (part) {
                nonEmptyParts.push(part);
            }
        }
        return nonEmptyParts.join(', ');
    };

    return (<div>
        <PopupField
            loading={props.loading}
            value={deliveryAddressAsString(props.value)}
            canEdit={!props.disableEdit}
            onOpen={() => setOpen(true)}
            property={'Delivery address'}
            highlightMandatoryFieldForRequester={props.highlightMandatoryFieldForRequester}
            highlightMandatoryFieldForSpender={props.highlightMandatoryFieldForSpender}
            mandatoryForSpender={props.mandatoryForSpender}
            mandatoryForRequester={props.mandatoryForRequester}
        />
        <DeliveryAddressPopup
            open={open}
            value={props.value}
            onSave={(address) => {
                setOpen(false);
                let addressToSave = address;
                if (!isAddressIdentical(props.value, address) || address.alternateAddress === true) {
                    addressToSave = {
                        ...address,
                        manuallyModified: true,
                    };
                }
                props.onSave(addressToSave);
            }}
            handleClose={() => setOpen(false)}
        />
    </div>);
};

DeliveryAddressField.propTypes = {
    value: PropTypes.object,
    onSave: PropTypes.func,
    inputRef: PropTypes.object,
    disableEdit: PropTypes.bool,
    loading: PropTypes.bool,
    mandatoryForSpender: PropTypes.bool,
    mandatoryForRequester: PropTypes.bool,
    highlightMandatoryFieldForRequester: PropTypes.bool,
    highlightMandatoryFieldForSpender: PropTypes.bool,
};


